import React, { useEffect, useState, useRef } from "react";
import { supabase } from "../supabase";
import { FaStar } from "react-icons/fa6";

function Testimonials() {
  const sliderRef = useRef(null);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  async function fetchTestimonials() {
    const { data, error } = await supabase.from("Testimonials").select("*").order("customer", { ascending: false });;

    if (!error) setTestimonials(data);
  }

  // Drag handlers (Desktop)
  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - sliderRef.current.offsetLeft;
    scrollLeft.current = sliderRef.current.scrollLeft;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    sliderRef.current.scrollLeft = scrollLeft.current - walk;
  };
  return (
    <>
      <section className="slider-wrapper mt-4">
        <div className="container">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center mt-3 mb-1">
              <div className="heading-dash" />
              <h5 className="fw-bold mb-0 d-flex align-items-center">
               Testimonials
              </h5>
            </div>
          </div>

          {/* Grid */}
          <div
            className="slider-track pb-4 pt-1"
            ref={sliderRef}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onMouseMove={handleMouseMove}
          >
            {testimonials.map((t) => (
              <div key={t.id} className="slider-card">
                {/* Author Info */}
                <div className="flex items-center border-t border-gray-50">
                  <img
                    src={t.photo || "https://via.placeholder.com/150"}
                    alt={t.customer}
                    className="w-6 h-6 object-cover shadow-sm" style={{width:'100px', height:'100px', borderRadius:'15px'}}
                  />
                </div>

                <div>
                  <h4 className="font-bold text-gray-900 leading-none mb-1">
                    {t.customer}
                  </h4>
                  <p className="text-xs font-semibold uppercase tracking-wider mt-1 mb-0">
                    {t.tag}
                  </p>
                  <p className="mb-2">
                   
                       {[...Array(t.rating || 5)].map((_, i) => (
                      <FaStar style={{ color: "orange", marginRight:'5px' }} />
                    ))}
                 
                  </p>
                </div>
                {/* Star Rating */}

                {/* Content */}
                <p className="mb-0">
                  "{t.review}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
